import React from 'react';
import { withRouter } from 'react-router';
import { Query, withApollo } from "react-apollo";

import { formatDate, formatTime, escapeHTML, replaceBulk } from '../../util';
import { updateComment } from '../../graphql/mutations';
import { clientCredentials } from '../../graphql/queries';
import { Avatar } from '../user'
import { CommentReplies, CommentAttachment, CommentDelete, CommentActions } from './index'
import { CardInline } from '../chunk'
import { PostAdd }  from "../post";
import CommentAttachmentDelete from './CommentAttachmentDelete';

class Comment extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			isEdit: false,
			body: props.message,
            savedBody: props.message,
			weblinks: props.weblinks,
		};

		this.mutate = this.mutate.bind(this);
		this.handleToggleEdit = this.handleToggleEdit.bind(this);
	}

	handleToggleEdit() {
		const isEdit = !this.state.isEdit;
		this.setState({isEdit, body: this.state.savedBody});
	}

	mutate() {

		const qlVars = {
			id: this.props.id,
			body: this.state.body
		}

		this.props.client.mutate({
			mutation: updateComment,
			variables: qlVars
		})
		.then(res => {
			this.setState({
				body: res.data.updateComment.body,
                savedBody: res.data.updateComment.body,
				weblinks: res.data.updateComment.weblinks,
				isEdit: false
			});
		})
	}
	
	formatMessage = () => {

		const findArray = [],
			replaceArray = [];

		for(let weblink of this.state.weblinks) {
			for(let alias of weblink.alias) {
				findArray.push(alias);

				const image = escapeHTML(weblink.image);
				const icon = escapeHTML(weblink.icon);
				const title = escapeHTML(weblink.title);

				replaceArray.push(`<a href="${alias}" target="_blank" rel="noopener noreferrer" class="tile">
				<div class="card">
					<div class="card-media card-media--large" style="background-image: url('${icon || image}')">
					</div>
					<div class="card-content card-content--inline">
						${title}
						<div class="meta" style="margin-top: 0.25rem;">
							<div>${alias}</div>
						</div>
					</div>
				</div>
			</a>`);
			}
		}
		
		let message = escapeHTML(this.state.body);
		message = message.replace(/&amp;/g, '&'); //replaceBulk breaks on &amp; - reset them
		return replaceBulk(message, findArray, replaceArray);
	}

	render() {

		let commentDate = formatDate(this.props.dateEdited ? this.props.dateEdited : this.props.date);
		commentDate += this.props.dateEdited ? '*' : '';
		const commentDateWithTime = commentDate + ' ' + formatTime(this.props.date);
		//const detailUrl = `${parentUrl}/post/${this.props.id}/`;

		const showFiles = this.props.files && !this.state.isEdit && this.props.files[0] !== null;
		
		const avatar = <Avatar user={this.props.user} />;
		const meta = <CommentActions handleEdit={this.handleToggleEdit} 
						id={this.props.id}
						votes={this.props.votes}
						user={this.props.user} />;

		return (
			<div className="comment">
				
				<div className="comment-body">

					{/* USER BANNER */}
					<CardInline media={avatar} meta={meta}>
						{this.props.user.name} 
						<span className="comment-meta" title={commentDateWithTime}>{commentDate}</span>
					</CardInline>

					{/* DEFAULT */}
					{!this.state.isEdit && (<p className="comment-msg" dangerouslySetInnerHTML={{__html: this.formatMessage()}}></p>)}
					
					{/* EDIT */}
					{this.state.isEdit && (
						<div className="comment-msg">
							<textarea className="textarea" rows="6" /*ref={input => input && input.focus()}*/
				      		value={this.state.body} onChange={e => this.setState({body: e.target.value})}></textarea>
							<div className="button-wrap">
								<CommentDelete commentId={this.props.id} buttonClass="button--secondary" label="delete post" />
								<button 
                                    onClick={() => this.handleToggleEdit()} 
                                    className="button button--secondary">cancel</button>
								<button onClick={this.mutate} className="button">update post</button>
							</div>
						</div>
					)}

					{/* EDIT ATTACHMENTS */}
					{this.state.isEdit && this.props.files.map(file => <CommentAttachmentDelete key={file.id} file={file} />)}

					{/* ATTACHMENTS */}
					{showFiles && this.props.files.map(file => <CommentAttachment key={file.id} file={file} />)}
					
					{/* REPLIES */}
					<CommentReplies children={this.props.children} />

					{/* REPLY */}
					{!this.state.isEdit && <Query query={clientCredentials}>
						{({ data: { clientCredentials }, client }) => {
							const avatar = <Avatar user={clientCredentials} style={{marginTop: '0.25rem'}} />;
							return (
								<CardInline media={avatar}>
									<PostAdd channel={this.props.match.params.id} reply={this.props.id} />
								</CardInline>
							)
						}}
					</Query>}
				</div>
		    </div>
		)
	}
}

export default withRouter(withApollo(Comment))


// WEBPACK FOOTER //
// ./src/components/comment/Comment.js